import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
      token: '',
      loading: true,
      siteinfo: [],
      channelList: [],
      isSelectingReportAction: false, // 增加标引
      choosedTagInfo: {title: ''},
      choosedReportInfo: {id: '', name: ''},
      isSelectingTagAction: false,
      addTaskInfo: {title: '', beginTime: '', endTime: '', content: '', executor: [], urgent: false, type: 1, selectedOptions: []},
      addTaskChoosedTagInfo: {id: '', name: ''}, // 添加任务时已选择的标引信息
      areaList: [],
      deptList: [],
      onceChoosedDeptsInfo: {},
      isSelectingTaskAction: false,
      choosedTaskInfo: {id: '', name: ''},
      isSelectingProgressAction: false,
      addProgressChoosedTaskInfo: {id: '', name: ''},
      addProgressInfo: {content: ''},
      articleClass: [{key:'1',label:'图文'}, {key:'2',label:'专题'}, {key:'3',label:'广告'}, {key:'4',label:'视频'}],
      choosedArticleInfo: {title: '', subtitle: '', content: '请输入内容', type: 1, videoId: '', videoName: ''},
      spinning: false,
  },
  mutations: {
      setToken(state,token) {
          if (token != '' && token != null) {
              state.token = token
          }
      },
      setSiteInfo(state, data){
          if (data != '' && data != null) {
              state.siteinfo = data
          }

      },
      loading(state, status) {
          state.loading = status
      },
      storeChanelList (state, channelList) {
          state.channelList = channelList
      },
      storeIsSelectingReportAction (state, isSelectingReportAction) {
          state.isSelectingReportAction = isSelectingReportAction
      },
      storeChoosedTagInfo (state, choosedTagInfo) {
          state.choosedTagInfo = choosedTagInfo
      },
      storeChoosedReportInfo (state, choosedReportInfo) {
          state.choosedReportInfo = choosedReportInfo
      },
      storeIsSelectingTagAction (state, isSelectingTagAction) {
          state.isSelectingTagAction = isSelectingTagAction
      },
      storeAddTaskInfo (state, addTaskInfo) {
          state.addTaskInfo = addTaskInfo
      },
      storeAddTaskChoosedTagInfo (state, addTaskChoosedTagInfo) {
          state.addTaskChoosedTagInfo = addTaskChoosedTagInfo
      },
      storeAreaList (state, areaList) {
          state.areaList = areaList
      },
      storeDeptList (state, deptList) {
          state.deptList = deptList
      },
      storeOnceChoosedDeptsInfo (state, onceChoosedDeptsInfo) {
          state.onceChoosedDeptsInfo = onceChoosedDeptsInfo
      },
      storeIsSelectingTaskAction (state, isSelectingTaskAction) {
          state.isSelectingTaskAction = isSelectingTaskAction
      },
      storeChoosedTaskInfo (state, choosedTaskInfo) {
          state.choosedTaskInfo = choosedTaskInfo
      },
      storeIsSelectingProgressAction (state, isSelectingProgressAction) {
          state.isSelectingProgressAction = isSelectingProgressAction
      },
      storeAddProgressChoosedTaskInfo (state, addProgressChoosedTaskInfo) {
          state.addProgressChoosedTaskInfo = addProgressChoosedTaskInfo
      },
      storeAddProgressInfo (state, addProgressInfo) {
          state.addProgressInfo = addProgressInfo
      },
      storeAddArticleInfo (state, choosedArticleInfo) {
          state.choosedArticleInfo = choosedArticleInfo
      },
  },
  actions: {

  }
})
